/* Lorelia · Schmuck-Produktseite (Nachtbau 28.09.2026; Live-Vorschau neu 05.10.2026 → lr-schv-vorschau.js). Kein Framework.
   Warenkorb wie bisher: /cart/add.js mit JSON, alle properties[...] des Formulars (nicht leer). */
(function () {
  'use strict';
  var d = document, root = d.querySelector('[data-sch]');
  d.documentElement.classList.add('sch-js-an');
  var ruhig = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var qs = function (s, r) { return (r || d).querySelector(s); };
  var qsa = function (s, r) { return Array.prototype.slice.call((r || d).querySelectorAll(s)); };
  var geld = function (c) { return '€' + (c / 100).toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); };

  /* ---------- Auftritt der unteren Abschnitte ---------- */
  function auftritt() {
    var ziele = qsa('[data-sch-auf],[data-sch-karten]');
    if (!('IntersectionObserver' in window) || ruhig) { ziele.forEach(function (e) { e.classList.add('is-da'); }); return; }
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-da'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -12% 0px' });
    ziele.forEach(function (e) { io.observe(e); });
  }
  auftritt();
  if (!root) return;

  var form = qs('[data-sch-form]', root);
  var idIn = qs('[data-sch-id]', root);
  var titel = root.getAttribute('data-title') || '';

  /* ---------- Galerie ---------- */
  var spur = qs('[data-sch-spur]', root), folien = qsa('[data-sch-folie]', root), punkte = qsa('[data-sch-punkte] button', root), gi = 0;
  function gehe(k, weich) { if (!spur || !folien.length) return; k = (k + folien.length) % folien.length; spur.scrollTo({ left: k * spur.clientWidth, behavior: weich === false || ruhig ? 'auto' : 'smooth' }); }
  function sync() {
    if (!spur) return; var k = Math.round(spur.scrollLeft / Math.max(1, spur.clientWidth)); if (k === gi) return; gi = k;
    punkte.forEach(function (p, j) { p.classList.toggle('is-an', j === gi); if (j === gi) p.setAttribute('aria-current', 'true'); else p.removeAttribute('aria-current'); });
    marke();
  }
  if (spur) {
    var st; spur.addEventListener('scroll', function () { clearTimeout(st); st = setTimeout(sync, 60); }, { passive: true });
    punkte.forEach(function (p, j) { p.addEventListener('click', function () { gehe(j); }); });
    qsa('[data-sch-pfeil]', root).forEach(function (b) { b.addEventListener('click', function () { gehe(gi + parseInt(b.getAttribute('data-sch-pfeil'), 10)); }); });
    spur.addEventListener('keydown', function (e) { if (e.key === 'ArrowRight') gehe(gi + 1); if (e.key === 'ArrowLeft') gehe(gi - 1); });
    window.addEventListener('resize', function () { gehe(gi, false); positioniere(); });
  }

  /* ---------- Vorschau ---------- */
  var cfg = null, roh = root.getAttribute('data-vorschau') || '';
  if (roh) { cfg = {}; roh.split(';').forEach(function (p) { var kv = p.split('='); if (kv.length === 2) cfg[kv[0].trim()] = kv[1].trim(); }); }
  /* 05.10.2026: Das alte Overlay auf Galeriebild 1 (Pixelkoordinaten im Template-Setting „vorschau“) ist abgelöst –
     die Galeriebilder werden getauscht, die Koordinaten stimmen dann nicht mehr. Die Vorschau zeichnet jetzt
     lr-schv-vorschau.js auf eigene Grundbilder. Nur wenn die nicht lädt, erscheint das Text-Schild als Ersatz. */
  cfg = null;
  var num = function (k, dflt) { var v = cfg && parseFloat(cfg[k]); return isNaN(v) ? dflt : v; };
  var pvs = qsa('[data-sch-pv]', root), schildText = qs('[data-sch-schildtext]', root);
  var nameIn = qs('[data-sch-name]', root) || qs('[data-sch-gravur]', root);
  var zuletzt = '';
  function esc(c) { return c === ' ' ? '&nbsp;' : c.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;'); }
  function buchstaben(text, alt) {
    var gleich = 0; while (gleich < alt.length && gleich < text.length && alt[gleich] === text[gleich]) gleich++;
    return text.split('').map(function (c, j) { return '<span class="sch-bu' + (j >= gleich && !ruhig ? ' is-neu' : '') + '">' + esc(c) + '</span>'; }).join('');
  }
  var neu = null;   /* neue Vorschau (lr-schv-vorschau.js) – ersetzt das Overlay auf Galeriebild 1 */
  function zeichne(text) {
    if (neu) { zuletzt = text; marke(); return; }
    var hat = text.trim().length > 0;
    if (schildText) schildText.innerHTML = hat ? buchstaben(text, zuletzt) : '';
    if (cfg) {
      pvs.forEach(function (pv) {
        if (!hat) { pv.classList.remove('is-an'); return; }
        var h = '';
        var fz = cfg.fleck === 'weiss' ? [1.16, 1.34] : [1, 1];
        if (cfg.fleck) h += '<i class="sch-fleck sch-fleck--' + cfg.fleck + '" style="left:' + num('fx', 50) + '%;top:' + num('fy', 50) + '%;width:' + (num('fb', 30) * fz[0]).toFixed(2) + 'cqw;height:' + (num('fh', 10) * fz[1]).toFixed(2) + 'cqw;transform:translate(-50%,-50%) rotate(' + num('w', 0) + 'deg)"></i>';
        if (cfg.linie) h += '<i class="sch-linie" data-l></i>';
        if (cfg.kette) h += '<i class="sch-kette" data-k="0"></i><i class="sch-kette" data-k="1"></i>';
        h += '<span class="sch-nm sch-nm--' + cfg.art + '" style="left:' + num('x', 50) + '%;top:' + num('y', 50) + '%;font-size:' + num('s', 20) + 'cqw;transform:translate(-50%,-50%) rotate(' + num('w', 0) + 'deg)">' + buchstaben(text, zuletzt) + '</span>';
        pv.innerHTML = h; pv.classList.add('is-an');
      });
      einpassen();
    }
    zuletzt = text; marke();
  }
  /* Schrift so verkleinern, dass der Name in die Breite b passt; Kettenstücke an die Enden setzen */
  function einpassen() {
    if (!cfg) return;
    pvs.forEach(function (pv) {
      var nm = qs('.sch-nm', pv); if (!nm) return;
      var W = pv.clientWidth; if (!W) return;
      var H = pv.clientHeight, s = num('s', 20), b = num('b', 40) / 100 * W;
      nm.style.fontSize = s + 'cqw';
      var w = nm.offsetWidth; if (w > b) { s = s * b / w; nm.style.fontSize = s.toFixed(3) + 'cqw'; w = nm.offsetWidth; }
      var cx = num('x', 50) / 100 * W, cy = num('y', 50) / 100 * H, wi = num('w', 0) * Math.PI / 180;
      if (cfg.kette) {
        var k = cfg.kette.split(',').map(parseFloat), halb = w / 2 - W * 0.012;
        var enden = [[cx - halb * Math.cos(wi), cy - halb * Math.sin(wi) + num('ky', 0) / 100 * W], [cx + halb * Math.cos(wi), cy + halb * Math.sin(wi) + num('ky', 0) / 100 * W]];
        var anker = [[k[0] / 100 * W, k[1] / 100 * H], [k[2] / 100 * W, k[3] / 100 * H]];
        qsa('.sch-kette', pv).forEach(function (el, j) {
          var a = anker[j], e = enden[j], dx = e[0] - a[0], dy = e[1] - a[1], len = Math.sqrt(dx * dx + dy * dy);
          if ((j === 0 && e[0] <= a[0] + 2) || (j === 1 && e[0] >= a[0] - 2)) { el.style.display = 'none'; return; }
          el.style.display = ''; el.style.left = a[0] + 'px'; el.style.top = (a[1] - W * 0.0025) + 'px'; el.style.width = len + 'px';
          el.style.transform = 'rotate(' + Math.atan2(dy, dx) + 'rad)';
        });
      }
      var l = qs('[data-l]', pv);
      if (l && cfg.l1 && cfg.l2) {
        var p1 = cfg.l1.split(',').map(parseFloat), p2 = cfg.l2.split(',').map(parseFloat);
        var x1 = p1[0] / 100 * W, y1 = p1[1] / 100 * H, x2 = p2[0] / 100 * W, y2 = p2[1] / 100 * H, lx = x2 - x1, ly = y2 - y1;
        l.style.left = x1 + 'px'; l.style.top = (y1 - W * 0.00475) + 'px'; l.style.width = Math.sqrt(lx * lx + ly * ly) + 'px';
        l.style.transformOrigin = '0 50%'; l.style.transform = 'rotate(' + Math.atan2(ly, lx) + 'rad)';
      }
    });
  }
  if (nameIn) {
    var schriftGeladen = false;
    var laden = function () { if (schriftGeladen || !d.fonts || !d.fonts.load) return; schriftGeladen = true; Promise.all([d.fonts.load('40px "Great Vibes"'), d.fonts.load('600 40px "Cormorant Garamond"')]).then(function () { einpassen(); }).catch(function () {}); };
    nameIn.addEventListener('focus', laden);
    nameIn.addEventListener('input', function () {
      laden(); zeichne(nameIn.value); fehlerWeg();
      if (gi !== 0) gehe(0);
    });
    /* Vorbelegung aus dem Wunschlink (?name=) */
    var pn = new URLSearchParams(location.search).get('name') || new URLSearchParams(location.search).get('gravur');
    if (pn) { nameIn.value = pn.slice(0, nameIn.maxLength > 0 ? nameIn.maxLength : 40); laden(); zeichne(nameIn.value); }
    if (d.fonts && d.fonts.ready) d.fonts.ready.then(einpassen);
  }

  /* ---------- Zeichengrenze: nie still abschneiden – am Feld erklären, warum nichts mehr dazukommt.
     Ohne maxlength-Attribut, weil Safari eingefügten Text sonst schon VOR jedem Ereignis kürzt (unsichtbar). ---------- */
  qsa('[data-sch-name],[data-sch-gravur]', root).forEach(function (i) {
    var max = i.maxLength > 0 ? i.maxLength : 0; if (!max) return;
    i.removeAttribute('maxlength'); i.setAttribute('data-sch-max', String(max));
    var box = i.closest('[data-sch-perso]'), f = box && qs('[data-sch-fehlt]', box);
    if (!f) { f = d.createElement('p'); f.className = 'sch-fehlt'; f.setAttribute('role', 'alert'); f.setAttribute('data-sch-fehlt', ''); if (box) box.appendChild(f); }
    function hinweis(zuviel) {
      if (zuviel) f.textContent = 'Höchstens ' + max + (max === 1 ? ' Zeichen' : ' Zeichen') + ' – mehr passt nicht auf dein Stück. Was darüber hinausgeht, wurde nicht übernommen.';
      else if (box && box.classList.contains('is-grenze')) f.textContent = '';
      if (box) box.classList.toggle('is-grenze', zuviel);
    }
    i.addEventListener('beforeinput', function (e) {
      if (!e.inputType || e.inputType.indexOf('insert') !== 0) return;
      var a0 = i.selectionStart || 0, a1 = i.selectionEnd || 0, daten = e.data != null ? e.data : ((e.dataTransfer && e.dataTransfer.getData('text/plain')) || '');
      if (!daten) return;
      var rest = max - (i.value.length - (a1 - a0));
      if (daten.length <= rest) { hinweis(false); return; }
      if (!e.cancelable) return;                                        /* Autokorrektur/IME: der input-Handler kürzt danach sichtbar */
      e.preventDefault();
      var teil = daten.slice(0, Math.max(0, rest));
      if (teil) { i.setRangeText(teil, a0, a1, 'end'); i.dispatchEvent(new Event('input', { bubbles: true })); }
      hinweis(true);
    });
    i.addEventListener('input', function (e) {
      /* Nur echte Eingaben begrenzen: lr-konfig schreibt bei zwei Initialen die Fertigungsangabe „A & J“ per Skript
         in dieses (dann versteckte) Feld – die darf nie gekürzt werden (Rauchtest R4, 05.10.2026 17:09). */
      if (!e.isTrusted) return;
      if (i.value.length > max) { i.value = i.value.slice(0, max); hinweis(true); i.dispatchEvent(new Event('input', { bubbles: true })); }
      else if (i.value.length < max) hinweis(false);
    });
  });

  /* ---------- Kleine Vorschau oben beim Tippen (Handy) ---------- */
  var mini = qs('[data-sch-mini]', root), buehne = qs('[data-sch-buehne]', root), buehneSicht = true;
  function positioniere() {
    if (!mini) return;
    var box = qs('[data-sch-minibild]', mini), eb = qs('.sch-ebene', box), img = qs('img', box);
    var bw = box.clientWidth || 168, bh = box.clientHeight || 112;
    var ar = (img.getAttribute('width') / img.getAttribute('height')) || 0.672;
    var fokusB = cfg ? Math.max(num('b', 40), num('fb', 0), 30) * 1.25 : 60;
    var ww = bw / (fokusB / 100), wh = ww / ar;
    var cx = cfg ? num('x', 50) : 50, cy = cfg ? num('y', 50) : 55;
    eb.style.right = 'auto'; eb.style.width = ww + 'px';
    eb.style.left = (bw / 2 - cx / 100 * ww) + 'px'; eb.style.top = (bh / 2 - cy / 100 * wh) + 'px';
    einpassen();
  }
  var miniZeigen = function () {};
  if (mini && buehne && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (es) { buehneSicht = es[0].isIntersecting; miniZeigen(); }, { threshold: 0.25 }).observe(buehne);
    var fokus = false, vv = window.visualViewport;
    miniZeigen = function () {
      var an = fokus && !buehneSicht && (neu ? root.classList.contains('schv-an') : cfg !== null);
      if (an && !neu) { var im = qs('img', mini); if (!im.src) { im.src = im.getAttribute('data-src'); } positioniere(); }
      if (an && neu) neu.mini(mini);
      mini.classList.toggle('is-an', an); mini.classList.toggle('is-neu', !!neu);
      lage();
    };
    /* iPhone: Bei offener Tastatur verschiebt Safari den sichtbaren Bereich – Mini-Vorschau oben im SICHTBAREN Bereich halten */
    var lage = function () { if (!vv) return; mini.style.transform = mini.classList.contains('is-an') ? 'translateY(' + Math.max(0, vv.offsetTop) + 'px)' : ''; };
    if (vv) { vv.addEventListener('resize', lage); vv.addEventListener('scroll', lage); }
    root.addEventListener('focusin', function (e) { if (e.target && e.target.matches && e.target.matches('[data-sch-name],[data-sch-gravur],[data-lrk-feld]')) { fokus = true; miniZeigen(); } });
    root.addEventListener('focusout', function (e) { if (e.target && e.target.matches && e.target.matches('[data-sch-name],[data-sch-gravur],[data-lrk-feld]')) { fokus = false; setTimeout(miniZeigen, 150); } });
    root.addEventListener('input', function () { if (fokus) setTimeout(miniZeigen, 0); });
  }

  /* ---------- Neue Live-Vorschau (Paket C, 05.10.2026): eigene Grundbilder + Konfiguration je Produkt-ID ---------- */
  (function () {
    var VERS = '7f2bdb82c3', geladen = false;
    var eigen = qs('script[src*="/lr-sch.js"]'); if (!eigen) return;
    var basis = eigen.src.split('?')[0].replace(/[^/]+$/, '');
    if (/[?&]schv=0/.test(location.search)) return;                     /* Notschalter zum Vergleich */
    function laden() {
      if (geladen) return; geladen = true;
      /* Adressen mit Shopifys eigener Version (asset_url) aus dem Abschnitt – ändern sich automatisch mit jeder neuen Datei */
      var jsUrl = root.getAttribute('data-schv-js') || (basis + 'lr-schv-vorschau.js?v=' + VERS);
      var kfUrl = root.getAttribute('data-schv-konfig') || (basis + 'lr-schv-konfig.json?v=' + VERS);
      var sc = d.createElement('script'); sc.src = jsUrl; sc.async = true;
      sc.onload = function () {
        if (!window.LRSchv) return;
        window.LRSchv.verbinden(root, { basis: basis, konfigUrl: kfUrl, beiAenderung: function () { marke(); miniZeigen(); } }).then(function (b) {
          if (!b) { ersatz(); return; }
          neu = b; root.classList.add('schv-aktiv');
          qsa('[data-sch-pv]', root).forEach(function (pv) { pv.classList.remove('is-an'); pv.innerHTML = ''; });
          if (schildText) schildText.innerHTML = '';
          root.classList.remove('ohne-pos');
          b.zeigen();
        });
      };
      sc.onerror = ersatz;
      d.head.appendChild(sc);
    }
    function ersatz() { if (!nameIn) return; root.classList.add('ohne-pos'); if (nameIn.value) zeichne(nameIn.value); }
    ['focusin', 'pointerdown', 'keydown'].forEach(function (ev) { root.addEventListener(ev, laden, { once: true, passive: true }); });
    if (nameIn && nameIn.value) laden();
    if ('requestIdleCallback' in window) requestIdleCallback(laden, { timeout: 3500 }); else setTimeout(laden, 2500);
  })();

  /* ---------- Varianten: Metall (mit Farbwipe) und weitere Optionen ---------- */
  var vdata = []; try { var vs = qs('[data-sch-varianten]', root); if (vs) vdata = JSON.parse(vs.textContent); } catch (e) {}
  var basis = parseInt(root.getAttribute('data-price'), 10) || 0, extra = 0;
  var wahl = [];
  qsa('[data-sch-gruppe]', root).forEach(function (g) { var an = qs('.is-an', g); wahl[parseInt(g.getAttribute('data-sch-gruppe'), 10)] = an ? an.getAttribute('data-val') : null; });
  var atcKnoepfe = qsa('[data-sch-atc]', root);
  function preise() {
    var t = geld(basis + extra);
    qsa('[data-sch-preis],[data-sch-summe],[data-sch-leistepreis]', root).forEach(function (e) { e.textContent = e.hasAttribute('data-sch-preis') ? geld(basis) : t; });
  }
  function variante() {
    var v = vdata.filter(function (x) { return wahl.every(function (s, k) { return s == null || x.o[k] === s; }); })[0];
    if (!v) return;
    idIn.value = v.id; basis = v.price; preise();
    atcKnoepfe.forEach(function (b) { b.disabled = !v.available; });
    var t = qs('[data-sch-atc-text]', root); if (t) t.textContent = v.available ? 'In den Warenkorb' : 'Derzeit ausverkauft';
  }
  var silberEbene = qs('[data-sch-ebene=silber]', root), glanz = qs('.sch-glanz', root), bildton = root.getAttribute('data-bildton');
  function metall(ton, weich) {
    var silber = ton === 'silber';
    if (mini) mini.classList.toggle('is-silber', silber && bildton === 'gold');
    if (silber === root.classList.contains('is-silber')) return;
    if (silber) { root.classList.remove('is-silber-raus'); root.classList.add('is-silber'); }
    else if (silberEbene && weich && !ruhig) {
      root.classList.add('is-silber-raus'); root.classList.remove('is-silber');
      setTimeout(function () { if (root.classList.contains('is-silber')) return; silberEbene.style.transition = 'none'; root.classList.remove('is-silber-raus'); void silberEbene.offsetWidth; silberEbene.style.transition = ''; }, 950);
    } else root.classList.remove('is-silber');
    if (glanz && weich && !ruhig) { glanz.classList.remove('is-lauf'); void glanz.offsetWidth; glanz.classList.add('is-lauf'); }
    if (weich && gi !== 0) gehe(0);
    marke();
  }
  function marke() { var hat = (nameIn && nameIn.value.trim().length > 0) || root.classList.contains('schv-an'); root.classList.toggle('is-vorschau', gi === 0 && (hat || root.classList.contains('is-silber'))); }
  qsa('[data-sch-metall],[data-sch-wahl]', root).forEach(function (b) {
    b.addEventListener('click', function () {
      var g = b.closest('[data-sch-gruppe]'), k = parseInt(g.getAttribute('data-sch-gruppe'), 10);
      qsa('button', g).forEach(function (x) { x.classList.toggle('is-an', x === b); x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
      wahl[k] = b.getAttribute('data-val'); var w = qs('[data-sch-wert]', g); if (w) w.textContent = wahl[k];
      variante();
      if (b.hasAttribute('data-sch-metall')) metall(b.getAttribute('data-ton'), true);
    });
  });
  var metAn = qs('[data-sch-metall].is-an', root); if (metAn && metAn.getAttribute('data-ton') === 'silber') metall('silber', false);

  /* ---------- Kettenlänge ---------- */
  var lenIn = qs('[data-sch-len-input]', root);
  qsa('[data-sch-len]', root).forEach(function (b) {
    b.addEventListener('click', function () {
      qsa('[data-sch-len]', root).forEach(function (x) { x.classList.toggle('is-an', x === b); x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
      /* Wert wie bisher (lr-product): nach Tippen nur die Zahl, z. B. "50" – die Fertigung kennt dieses Format */
      if (lenIn) lenIn.value = b.getAttribute('data-sch-len');
      var l = qs('[data-sch-lenwert]', root); if (l) l.textContent = b.getAttribute('data-sch-len') + ' cm';
    });
  });

  /* ---------- Geschenk ---------- */
  var gSchalter = qs('[data-sch-geschenk]', root);
  if (gSchalter) {
    var gInhalt = qs('#sch-geschenk-inhalt', root), gIn = qs('[data-sch-gift]', root), npIn = qs('[data-sch-noprice]', root), npBox = qs('[data-sch-ohnepreis]', root), karte = qs('#sch-karte', root);
    gSchalter.addEventListener('click', function () {
      var an = gSchalter.getAttribute('aria-checked') !== 'true';
      gSchalter.setAttribute('aria-checked', an ? 'true' : 'false'); gInhalt.hidden = !an; gIn.value = an ? 'Ja' : '';
      if (!an) { if (karte) karte.value = ''; if (npBox) npBox.checked = false; if (npIn) npIn.value = ''; }
    });
    if (npBox) npBox.addEventListener('change', function () { npIn.value = npBox.checked ? 'Ja' : ''; });
  }

  /* ---------- In den Warenkorb ---------- */
  var meldung = qs('[data-sch-meldung]', root), brauchtSteine = root.getAttribute('data-need-stones') === 'true';
  function fehlerWeg() { var p = nameIn && nameIn.closest('[data-sch-perso]'); if (p && p.classList.contains('is-fehlt')) { p.classList.remove('is-fehlt'); var f = qs('[data-sch-fehlt]', p); if (f && !p.classList.contains('is-grenze')) f.textContent = ''; } }
  function hinScrollen(el) { el.scrollIntoView({ behavior: ruhig ? 'auto' : 'smooth', block: 'center' }); }
  function absenden(e) {
    if (e) e.preventDefault();
    if (brauchtSteine) {
      var p1 = qs('[data-prop1]', form), p2 = qs('[data-prop2]', form);
      if (!p1.value || !p2.value) { meldung.textContent = 'Bitte wähle zuerst beide Steine.'; var pk = qs('[data-lr-picker]', root); if (pk) hinScrollen(pk); return; }
    }
    if (nameIn && nameIn.required && !nameIn.value.trim()) {
      var box = nameIn.closest('[data-sch-perso]'); box.classList.remove('is-fehlt'); void box.offsetWidth; box.classList.add('is-fehlt');
      var f = qs('[data-sch-fehlt]', box); if (f) f.textContent = 'Bitte trag hier zuerst ein, was auf dein Stück soll.';
      hinScrollen(box); setTimeout(function () { nameIn.focus({ preventScroll: true }); }, ruhig ? 0 : 450); return;
    }
    var item = { id: parseInt(idIn.value, 10), quantity: 1, properties: {} };
    qsa('[name^="properties["]', form).forEach(function (i) { if (i.disabled || !i.value) return; item.properties[i.name.slice(11, -1)] = i.value; });
    var items = [item];
    var boxId = root.getAttribute('data-box-id');
    if (boxId && gSchalter && gSchalter.getAttribute('aria-checked') === 'true') { items.push({ id: parseInt(boxId, 10), quantity: 1 }); item.properties.Verpackung = root.getAttribute('data-box-name') || item.properties.Verpackung; }
    atcKnoepfe.forEach(function (b) { b.setAttribute('aria-busy', 'true'); });
    meldung.textContent = '';
    window.fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items }) })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        atcKnoepfe.forEach(function (b) { b.removeAttribute('aria-busy'); });
        if (!res.ok) { meldung.textContent = (res.j && res.j.description) || 'Das hat nicht geklappt. Bitte versuch es noch einmal.'; return; }
        atcKnoepfe.forEach(function (b) { b.classList.add('is-drin'); var t = qs('[data-sch-atc-text]', b); if (t) t.textContent = '✓ Im Warenkorb'; else b.textContent = '✓ Im Warenkorb'; });
        meldung.textContent = titel + ' liegt im Warenkorb.';
        d.dispatchEvent(new CustomEvent('cart:update', { bubbles: true }));
        zaehler();
        setTimeout(function () { location.href = '/cart'; }, 1100);
      })
      .catch(function () { atcKnoepfe.forEach(function (b) { b.removeAttribute('aria-busy'); }); meldung.textContent = 'Das hat nicht geklappt. Bitte versuch es noch einmal.'; });
  }
  function zaehler() {
    window.fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) {
      var icon = d.querySelector('cart-icon'); if (!icon) return;
      var n = qs('[ref="cartBubbleCount"]', icon), bub = qs('[ref="cartBubble"]', icon);
      if (n) n.textContent = c.item_count; if (bub) { bub.classList.remove('hidden', 'visually-hidden'); bub.removeAttribute('hidden'); }
    }).catch(function () {});
  }
  if (form) form.addEventListener('submit', absenden);
  atcKnoepfe.forEach(function (b) { if (b.type !== 'submit') b.addEventListener('click', absenden); });

  /* ---------- Klebende Leiste, sobald das Formular nach oben aus dem Bild ist ---------- */
  var leiste = qs('[data-sch-leiste]', root), cta = qs('[data-sch-cta]', root);
  if (leiste && cta && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (es) {
      var e = es[0], vorbei = !e.isIntersecting && e.boundingClientRect.top < 0;
      leiste.classList.toggle('is-an', vorbei); leiste.setAttribute('aria-hidden', vorbei ? 'false' : 'true');
      qsa('button', leiste).forEach(function (b) { b.tabIndex = vorbei ? 0 : -1; });
    }).observe(cta);
  }
  preise();
})();
